// TooltipButton.js
import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import tooltipTexts from './Tooltipstext';
import './popover.css';
import { BsExclamationCircle } from 'react-icons/bs';

const TooltipButton = ({
  fieldName,
  placement = 'right',
  icon = null,
  isfont,
  ...iconProps
}) => {
  const tooltipText = tooltipTexts[fieldName] || 'Tooltip not found';

  const renderTooltip = (props) => (
    <Tooltip id="tooltip" {...props} className="custom-skew-tooltip">
      <span className="tooltip-inner-content"> {tooltipText.split('\n').map((line, i) => (
        <div key={i}>{line}</div>
      ))}</span>
    </Tooltip>
  );

  return (
    <OverlayTrigger placement={placement} overlay={renderTooltip}>
      <span {...iconProps} style={{ cursor: 'pointer', display: 'inline-block', fontSize:"16px"}}>
      <BsExclamationCircle style={{color:"black" , fontSize:isfont && "12px"}}/>
      </span>
    </OverlayTrigger>
  );
};

export default TooltipButton;
